import React, { useEffect, useState, useRef } from 'react';
import '../index.css';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles } from '@material-ui/core/styles';
import { getDate, prospectDetailsPath, investmentSatisfactionPath, prospectSatisfactionPath, searchFilter, handleSort } from "../utils/varialbles";
import Paper from '@material-ui/core/Paper';

import { Select, MenuItem, TextField, RadioGroup, FormControl, FormControlLabel, Radio, Input } from '@material-ui/core';
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import http from "../services/httpService";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import toast from 'react-hot-toast';
import handleValidation from '../utils/handleValidations';
import handleSubmitValidation from '../utils/handleSubmitValidation';
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#F5F7FA",
        padding: "7px",
        width: "100%"
    },
    paper: {
        paddingTop: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    submitButton: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(10),


    },
    gridDevider: {
        marginTop: theme.spacing(6),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    lableColor: {
        color: "#393939"
    },
    select: {
        height: 36,
        minWidth: 235,

    },
    mobileCode: {
        height: 36,
    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    },
    reviewButton: {
        borderRadius: "20px",
        border: "1px solid #2835D5",
        opacity: 1,
        textAlign: "right"
    },
    checked: {}

}));
function AddReview() {
    let history = useHistory();
    const [formObject, setFromObject] = useState({});
    let [lookupFile, setLookupFile] = useState(null);
    const classes = useStyles();
    const location = useLocation();
    const fileInputRef = useRef(null)

    const myparam = location.state;
    let form = {
        'cust': "",
        'platform_name': "",
        'url': "",
        'r1': "",
        'r2': "",
        'tags': "",
        'comment': "",
        'screenshot': null,
    }
    const columns = [
        { "value": 'platform_name', "imp":true, "label": 'Platform Name', minWidth: 170, "filedType": "dropdown", 
        "options": [{"label": "Play Store", "value": "Play Store" }, 
        { "label": "App Store", "value": "App Store" },
        { "label": "Google", "value": "Google" },
        { "label": "Facebook", "value": "Facebook" },
    ]},
        { "value": 'url', "imp":true, "label": 'Add URL', minWidth: 150, "filedType": "text" },
        { "value": 'rating', "imp":true, "label": 'Rating', minWidth: 150, "filedType": "text" },
        { "value": 'tags', "imp":true, "label": 'Tags', minWidth: 150, "filedType": "text" },
        { "value": 'comment', "imp":true, "label": 'Comments', minWidth: 150, "filedType": "textarea", multiline: true, rows: 5 },
        { "value": 'screenshot', "imp":true, "label": 'Screenshot', minWidth: 150, "filedType": "file" },
    ];
    const validations = {
        "platform_name": {
            conditions: {
                "required": true
            }, "message": "This Field is required!", "valid": true, "changed": false
        },
        "url": {
            conditions: {
                "required": true
            }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
        },
        "r1": {
            conditions: {
                "required": true, "maxValue": 10,"minValue":1
            }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
        },
        "r2": {
            conditions: {
                "required": true, "maxValue": 10,"minValue":1
            }, "message": "Maximum 500 Words Allowed.!", "valid": true, "changed": false
        },
        "tags": {
            conditions: {
                "required": true, "maxLength": 200
            }, "message": "Maximum 500 Words Allowed.!", "valid": true, "changed": false
        },
        "screenshot": {
            conditions: {
                "required": true, "maxLength": 200
            }, "message": "Maximum 500 Words Allowed.!", "valid": true, "changed": false
        },
        "comment": {
            conditions: {
                "required": true, "maxLength": 1000
            }, "message": "Maximum 500 Words Allowed.!", "valid": true, "changed": false
        }

    }
    const [validationState, setValidationState] = useState(validations)
    useEffect(() => {
        setFromObject(form)

    }, [])
    const handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let valid = true;
        let validStateTemp = { ...validationState }
        if (name && validStateTemp.hasOwnProperty(name)) {
            let validation = handleValidation(name, value, validStateTemp);

            setValidationState(validation.validStateTemp)
            valid = validation.valid
        }
        if (valid || value === "" || value === 0) {
            setFromObject({
                ...formObject,
                [event.target.name]: event.target.value
            });
        }

    }
    const gotoProspectDetails = (e) => {
        e.preventDefault();
        history.push({
            "pathname": prospectDetailsPath, state: myparam
        });
    }
    const gotoSatisFaction = () => {
        if (myparam && myparam.cust__id) {
            history.push({
                "pathname": prospectSatisfactionPath, state: myparam
            });
        } else if (myparam && myparam.customer_id) {
            history.push({
                "pathname": investmentSatisfactionPath, state: myparam
            });
        }
    }
    const handleFileChange = (event) => {
        let validStateTemp = { ...validationState }
        let validation = handleValidation("screenshot",  event.target.files&&event.target.files[0]?event.target.files[0]:null, validStateTemp);
        setValidationState(validation.validStateTemp)
        setLookupFile(event.target.files[0])
    }
    useEffect(() => {
        if (myparam && (myparam.cust__id || myparam.customer_id)) {

        } else {
            history.goBack()
        }
    }, [])
    const handleSubmit = (event) => {
        event.preventDefault();
        let validStateTemp = { ...validationState }
        let validCount = 0;
        let finalObjet = { ...formObject };
        finalObjet['screenshot']=lookupFile;
        let validData = handleSubmitValidation(finalObjet, validStateTemp)
        validCount = validData.validCount;
        if (validCount === 0) {
            const formData = new FormData();
            formData.append("cust", myparam.cust__id || myparam.customer_id);
            formData.append("platform_name", formObject["platform_name"]);
            formData.append("url", formObject["url"]);
            formData.append("rating", formObject["r1"] + "/" + formObject["r2"]);
            formData.append("tags", formObject["tags"]);
            formData.append("comment", formObject["comment"]);
            if (lookupFile) {
                formData.append("screenshot", lookupFile, lookupFile["name"]);
            }
            http.post("/prospect_review", formData,
            ).then((response) => {
                if (response.data.id) {
                    toast.success("Review Inserted Successfully..!");
                    gotoSatisFaction()
                } else {
                    toast.error("Review insersion Failed..!");
                }
            }).catch((error) => {
                toast.error("Review insersion Failed..!");
            })
        } else {
            setValidationState(validData.validStateTemp);
            toast.error("Please check Errors in Field level!")
        }
    }
    return (

        <Grid container component="main" className="pb30">
            <Paper className={classes.root}>
                <Grid container >
                    <Grid item xs={12} sm={12} md={2} className={"overviewbar"}>
                        <Button name="Overview" variant="contained" color="primary" onClick={gotoSatisFaction}>Overview</Button>
                    </Grid>
                </Grid>
            </Paper>
            <Grid item xs={false} sm={5} md={5} style={{ marginTop: 30 }}>
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={gotoSatisFaction}>Back</Button>
            </Grid>
            <Grid item xs={false} sm={5} md={5} style={{ marginTop: 30 }}>
                <Typography color="textPrimary" variant="h5" >Add Review</Typography>
            </Grid>
            <Grid container style={{ marginTop: 50 }}>
                {
                    columns.map((question, inx) => {
                        return (
                            <Grid container className={classes.paper} key={question.label + inx}>
                                <Grid item xs={12} sm={3} md={3} className={"formLable"}>
                                    <InputLabel className={classes.lableColor} id={question.lable}>{question.label}
                                    {question.imp && <span style={{color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem'}}>*</span>}
                                </InputLabel>
                                </Grid>
                                <Grid item lg={7} md={9} sm={9} xs={12}>{(question.filedType === "text" && question.value == "rating") ? <Grid container><Grid item xs={6} sm={4} md={6} lg={2}>
                                    <TextField label="Enter" variant="outlined" value={formObject["r1"]} name={"r1"} onChange={handleChange} type="number"
                                        style={validationState.hasOwnProperty("r1") && validationState["r1"]['changed'] && !validationState["r1"]['valid'] ? { paddingBottom: 20 } : {}}
                                        error={validationState.hasOwnProperty("r1") && validationState["r1"]['changed'] && !validationState["r1"]['valid']}
                                        helperText={validationState.hasOwnProperty("r1") && validationState["r1"]['changed'] && !validationState["r1"]['valid'] ? validationState["r1"]['message'] : ""}
                                    /></Grid>
                                    <span style={{ marginRight: 15, marginLeft: 15, fontWeight: 700, paddingTop: 10 }}>/</span><Grid item xs={6} sm={4} md={6} lg={2}>
                                        <TextField label="Enter" variant="outlined" value={formObject["r2"]} name={"r2"} onChange={handleChange} type="number"
                                            style={validationState.hasOwnProperty("r2") && validationState["r2"]['changed'] && !validationState["r2"]['valid'] ? { paddingBottom: 20 } : {}}
                                            error={validationState.hasOwnProperty("r2") && validationState["r2"]['changed'] && !validationState["r2"]['valid']}
                                            helperText={validationState.hasOwnProperty("r2") && validationState["r2"]['changed'] && !validationState["r2"]['valid'] ? validationState["r2"]['message'] : ""}
                                        /></Grid>
                                </Grid> : question.filedType === "radio" ?
                                    <RadioGroup row aria-label="position" name={question.value} defaultValue="A" value={formObject[question.value] ? formObject[question.value] : "A"} onChange={handleChange}>
                                        {
                                            question.options.map((option, inxinner) => {
                                                return (
                                                    <FormControlLabel
                                                        control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value={option.value} />}
                                                        label={option.label}
                                                        labelPlacement="end"
                                                    />
                                                )
                                            })

                                        }


                                    </RadioGroup> : question.filedType === "file" ?
                                        <>
                                            <input
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                                type="file"
                                                style={{ display: "none" }}
                                                multiple={false}
                                                accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                                            />
                                            <Button startIcon={<AddCircleOutlineIcon />} variant="outlined" className={classes.reviewButton} color="primary" onClick={() => fileInputRef.current.click()}>Choose File</Button>
                                            <span style={{ marginLeft: 10 }}>{lookupFile && lookupFile.name ? lookupFile.name : "No file chosen"}</span>
                                            {validationState.hasOwnProperty(question.value)
                                                        && validationState[question.value]['changed'] &&
                                                        !validationState[question.value]['valid'] ?
                                                        <div style={{ color: "#f44336", fontSize: "0.75rem", margin: "3px 14px" }}>{validationState[question.value]['message']}</div> : null}
                                            </>
                                        : (question.filedType === "dropdown") ?
                                            <><Select displayEmpty labelId="statusLable" id="statusSelect" variant="outlined" className={classes.select} onChange={handleChange} value={(formObject[question.value]) ? formObject[question.value] : ""} name={question.value}
                                                style={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? { paddingBottom: 20, width: 335 } : { width: 335 }}
                                                error={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid']}
                                                helperText={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? validationState[question.value]['message'] : ""}
                                            >
                                                <MenuItem value="">Select</MenuItem>
                                                {question.options.map((option, inxinner) => {

                                                    return <MenuItem value={option.value} key={option.label + inxinner}>{option.label}</MenuItem>
                                                })}

                                            </Select>
                                                {validationState.hasOwnProperty(question.value)
                                                    && validationState[question.value]['changed'] &&
                                                    !validationState[question.value]['valid'] ?
                                                    <div style={{ color: "#f44336", fontSize: "0.75rem", margin: "3px 14px" }}>{validationState[question.value]['message']}</div> : null}
                                            </> : (question.filedType === "textarea") ?
                                                <TextField label="Enter" variant="outlined" value={formObject[question.value]} name={question.value} onChange={handleChange} multiline rows={question.rows} style={{ width: 335 }}
                                                    style={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? { paddingBottom: 20, width: 335 } : { width: 335 }}
                                                    error={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid']}
                                                    helperText={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? validationState[question.value]['message'] :
                                                        `${formObject[question.value] ? formObject[question.value].length : 0}/${validationState[question.value] && validationState[question.value]["conditions"]['maxLength']}`
                                                    }
                                                />
                                                : (question.filedType === "text") ?
                                                    <TextField label="Enter" variant="outlined" value={formObject[question.value]} name={question.value} onChange={handleChange} className={classes.select}
                                                        style={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? { paddingBottom: 20, width: 335 } : { width: 335 }}
                                                        error={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid']}
                                                        helperText={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? validationState[question.value]['message'] : ""}
                                                    /> : ""}
                                </Grid>
                            </Grid>
                        )
                    })
                }
            </Grid>
            <Grid container className={classes.submitButton}>
                <Grid item xs={false} sm={5} md={5} >

                </Grid>


                <Grid item xs={12} sm={5} md={5} >
                    <Button variant="contained" color="primary" onClick={handleSubmit}>Add Review</Button>
                </Grid>
            </Grid>
        </Grid>
    )

}


export default AddReview;